<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card outlined>
      <v-card-title class="headline font-weight-light">Cancel updates?</v-card-title>
      <v-card-text>All changes to the play will be lost.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text color="dw_green" @click="confirm">Yes</v-btn>
        <v-btn small text color="dw_green" @click="dialog = false">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmCancel',
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    confirm() {
      this.$emit('confirmed');
      this.dialog = false;
    }
  }
};
</script>
